import { empresaService } from '@/modules/settings-center/sections/empresa'
import type { EmpresaSettings } from '@/modules/settings-center/sections/empresa'

import type { DeliveryBranding } from '../types'
import { DEFAULT_DELIVERY_BRANDING } from '../types'
import type { ClientPdfCompany } from './client-pdf-document'
import { compactText } from './client-pdf-document'

function formatAddress(empresa: EmpresaSettings): string | undefined {
  const { endereco } = empresa
  const parts = [
    [endereco.logradouro, endereco.numero].filter(Boolean).join(', '),
    endereco.complemento,
    endereco.bairro,
    [endereco.cidade, endereco.uf].filter(Boolean).join('/'),
    endereco.cep,
  ].filter((part) => part.trim())
  return parts.length > 0 ? parts.join(' · ') : undefined
}

export function companyFromEmpresa(
  empresa: EmpresaSettings = empresaService.get(),
): ClientPdfCompany {
  const name =
    compactText(empresa.nomeFantasia) ||
    compactText(empresa.razaoSocial) ||
    'Master Informática'

  const logo = compactText(empresa.logo)
  const logoDataUrl = logo?.startsWith('data:') ? logo : undefined

  return {
    name,
    tagline: 'SOLUÇÕES EM TECNOLOGIA',
    city: compactText(empresa.endereco.cidade),
    cnpj: compactText(empresa.cnpj),
    phone: compactText(empresa.telefone) || compactText(empresa.whatsapp),
    email: compactText(empresa.email),
    address: formatAddress(empresa),
    logoDataUrl,
  }
}

export function brandingFromEmpresa(
  empresa: EmpresaSettings = empresaService.get(),
): DeliveryBranding {
  const company = companyFromEmpresa(empresa)
  return {
    ...DEFAULT_DELIVERY_BRANDING,
    companyName: company.name,
    tagline: company.tagline,
    city: company.city || DEFAULT_DELIVERY_BRANDING.city,
  }
}
